import type { uuid } from "@/interfaces";
import type { AppointmentJoin } from "@/repositories/appointments.repository";

export const worksTheJob = (appointment: Pick<AppointmentJoin, "assigned_user">, userId: uuid | undefined): boolean =>
  userId !== undefined && appointment.assigned_user?.id === userId;
